import { useState, useEffect } from "react";
import "./QuestionRadio.scss";

import ButtonSubmit from "../ButtonSubmit";
import ProgressDots from "../ProgressDots/ProgressDots";
import RadioOption from "./RadioOption";

import { useWizardAnswers } from "ui-components";
import { stepFieldMap } from "../../constants/index";
import { simplyClick } from "../../helpers";

const QuestionRadio = ({
  nextStep,
  options,
  title,
  titleHeader,
  activeDot,
  eventOption,
  eventAction,
  step,
}) => {
  const [selected, setSelected] = useState("");
  const updateAnswer = useWizardAnswers();
  const field = stepFieldMap[step];

  useEffect(() => {
    setSelected("");
  }, [step]);

  const handleSelect = (value, index) => {
    setSelected(value);

    simplyClick(eventOption, { text: value.value || value });

    if (field) {
      const entries = Object.entries(options);
      const optionEntry = entries[index];
      const optionObj = optionEntry ? optionEntry[1] : null;
      const indexValue =
        typeof optionObj === "object" && optionObj.index
          ? optionObj.index
          : index + 1;

      updateAnswer({ [field]: [String(indexValue)] });
    }
  };

  const handleAction = (action) => {
    if (field && !selected) {
      updateAnswer({ [field]: ["0"] });
    }
    if (field && action === "skip") {
      updateAnswer({ [field]: ["0"] });
    }
    simplyClick(eventAction, { text: action });
    nextStep();
  };

  return (
    <div className="radio__form-wrapper">
      <div className="user__form-top">
        <h3>{titleHeader}</h3>
      </div>

      <div className="question__form-content">
        <p className="title_question">{title}</p>

        <div className="text__wrapper">
          <ul className="radio__list">
            {Object.entries(options).map(([label, value], index) => (
              <RadioOption
                key={index}
                name={title}
                label={label}
                value={value}
                selected={selected}
                onSelect={(v) => handleSelect(v, index)}
              />
            ))}
          </ul>
        </div>

        <div className="btn_group">
          <ButtonSubmit
            onClick={() => handleAction("skip")}
            disabled={!selected}
            className="button__global button_skip"
            text="SKIP"
          />
          <ButtonSubmit
            onClick={() => handleAction("next")}
            disabled={!selected}
            className="button__global"
            text="NEXT"
          />
        </div>

        <ProgressDots total={12} activeCount={activeDot} />
      </div>
    </div>
  );
}

export default QuestionRadio;
